import moment from "moment";

const MINUTES_IN_HOUR = 60;

export const defaultFormat = (localDateTime: string) => {
    const date = moment.utc(localDateTime).local();
    const formattedDate  = date.format("lll");
    return formattedDate
}

export const defaultFormatWithOutHours = (localDateTime: string) => {
    return moment.utc(localDateTime).local().format("lll");    
}

export function formatDaysAgo(numMin: number) {  
  return moment.duration(numMin, 'minutes').humanize();
}

export function fromNow(dateString: string) {

  if (!dateString) return "---";
  return moment.utc(dateString).fromNow(); 
}